/** Build-time config. Set VITE_API_URL in web/.env (see .env.example). */
export const API_URL: string = import.meta.env.VITE_API_URL ?? '';
export const APP_VERSION: string = '0.2.0';

if (!API_URL) {
  // eslint-disable-next-line no-console
  console.warn('VITE_API_URL is not set — API calls will fail. Copy web/.env.example to web/.env.');
}
